import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  checkInputContainer: {
    display: 'flex',
    gap: '40px',
    marginBottom: '16px',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '10px'
    }
  },

  container: {
    display: 'flex',
    gap: 24,

    '& div': {
      width: '100%'
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },

  section: {
    marginTop: 40
  },

  sectionTitle: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    borderBottom: '1px solid #E5E5E5',
    fontSize: '18px',
    width: '100%',
    padding: '0 0 8px',
    marginBottom: '16px',
    marginTop: '-18px'
  },

  inputContainer: {
    marginTop: 20
  }
}))
